"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interstitialVars = exports.default = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var interstitialVars = exports.interstitialVars = (0, _initVars.default)({
  variables: [{
    key: "width"
  }, {
    key: "height"
  }]
});
var interstitialStyles = function interstitialStyles(theme) {
  return {
    variables: interstitialVars.styles,
    root: {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      "& div": {
        boxSizing: "content-box",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "center",
        width: interstitialVars.get("width", "400px"),
        maxWidth: "100%",
        height: interstitialVars.get("height"),
        border: "none",
        "@media (max-width: 496px)": {
          backgroundColor: "transparent",
          boxShadow: "none"
        },
        "&:nth-child(2)": {
          backgroundColor: "transparent"
        }
      }
    },
    blur: {
      backdropFilter: "blur(2px)"
    },
    "@keyframes ModalOpen": {
      "0%": {
        opacity: 0
      },
      "100%": {
        opacity: 1
      }
    },
    "@keyframes ModalClose": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    content: {
      color: theme.colors.baseContrast100,
      alignItems: "center",
      wordWrap: "break-word",
      textAlign: "center",
      "@media (max-width: 496px)": {
        color: theme.colors.textOnDark
      }
    },
    title: {
      fontSize: 20,
      fontWeight: 600,
      maxWidth: "100%"
    },
    subText: {
      fontSize: 20,
      fontWeight: 400,
      maxWidth: "100%"
    },
    icon: {
      padding: theme.spacing.base * 4
    }
  };
};
var useInterstitialStyles = (0, _createUseStyles.default)(interstitialStyles, {
  name: "Interstitial"
});
var _default = exports.default = useInterstitialStyles;